import client from '@/api/base';

export default {
  // Account email
  async accountCreate(data) {
    const response = await client.post('account/email-confirm/', data);
    return response;
  },

  async emailValidation(uid, token) {
    const response = await client.post(`account/email-activate/${uid}/${token}/`);
    return response;
  },

  // Org sign-up
  async organizationSignUp(data) {
    const response = await client.post('account/org/signup/admin/', data);
    return response;
  },

  async memberSignUp(data) {
    const response = await client.post('account/org/signup/member/', data);
    return response;
  },

  // Email temp
  async resendEmailConfirmation(email) {
    const response = await client.post(`account/temp/${email}/re-send/`);
    return response;
  },

  async deleteTempUser(email) {
    const response = await client.delete(`account/temp/${email}/`);
    return response;
  },
};
